import { Button } from '@radix-ui/themes';
import { ListCollapse } from 'lucide-react';
import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex max-h-screen h-screen overflow-hidden">
      {/* Sidebar */}
      <aside
        className={`xl:block w-64 flex-shrink-0 ${
          isSidebarOpen ? 'block' : 'hidden'
        }`}
      >
        <Sidebar isOpen={true} onClose={() => {}} />
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header />
        <main className="flex-1 p-8 bg-gray-200 relative overflow-auto">
          {/* Button to open sidebar for small screens */}
          <Button
            color="gray"
            variant="ghost"
            radius="medium"
            className="xl:hidden fixed top-4 left-4 z-20 p-2"
            onClick={toggleSidebar}
          >
            <ListCollapse className="h-6 w-6" />
          </Button>

          {/* Sidebar for small screens */}
          <Sidebar isOpen={isSidebarOpen} onClose={toggleSidebar} />

          <div className="bg-white p-1 rounded-md shadow-sm ">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default Layout;
